// src/utils/asciiArtDecoderWorkerHelper.js
import Worker from '../workers/asciiDecoder.worker.js'

class AsciiArtDecoderWorkerHelper {
  constructor() {
    this.worker = new Worker()
  }

  decode(encodedData, customCharSets) {
    return new Promise((resolve, reject) => {
      const messageHandler = e => {
        this.worker.removeEventListener('message', messageHandler)
        resolve(e.data)
      }

      const errorHandler = error => {
        this.worker.removeEventListener('error', errorHandler)
        reject(error)
      }

      this.worker.addEventListener('message', messageHandler)
      this.worker.addEventListener('error', errorHandler)

      this.worker.postMessage({
        encodedData,
        customCharSets,
        useCustom: !!customCharSets
      })
    })
  }

  terminate() {
    this.worker.terminate()
  }
}

export default AsciiArtDecoderWorkerHelper
